import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/arrows/decor-arrow-next.svg")